"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Object = _interopRequireDefault(require("../Object.js"));

var _MapEventType = _interopRequireDefault(require("../MapEventType.js"));

var _functions = require("../functions.js");

var _events = require("../events.js");

var _dom = require("../dom.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var __extends = void 0 && (void 0).__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
/**
 * @module ol/control/Control
 */


/**
 * @typedef {Object} Options
 * @property {HTMLElement} [element] The element is the control's
 * container element. This only needs to be specified if you're developing
 * a custom control.
 * @property {function(import("../MapEvent.js").default):void} [render] Function called when
 * the control should be re-rendered. This is called in a `requestAnimationFrame`
 * callback.
 * @property {HTMLElement|string} [target] Specify a target if you want
 * the control to be rendered outside of the map's viewport.
 */

/**
 * @classdesc
 * A control is a visible widget with a DOM element in a fixed position on the
 * screen. They can involve user input (buttons), or be informational only;
 * the position is determined using CSS. By default these are placed in the
 * container with CSS class name `ol-overlaycontainer-stopevent`, but can use
 * any outside DOM element.
 *
 * This is the base class for controls. You can use it for simple custom
 * controls by creating the element with listeners, creating an instance:
 * ```js
 * var myControl = new Control({element: myElement});
 * ```
 * and then adding this to the map.
 *
 * The main advantage of having this as a control rather than a simple separate
 * DOM element is that preventing propagation is handled for you. Controls
 * will also be objects in a {@link module:ol/Collection~Collection}, so you can use their methods.
 *
 * You can also extend this base for your own control class. See
 * examples/custom-controls for an example of how to do this.
 *
 * @api
 */
var Control =
/** @class */
function (_super) {
  __extends(Control, _super);
  /**
   * @param {Options} options Control options.
   */


  function Control(options) {
    var _this = _super.call(this) || this;

    var element = options.element;

    if (element && !options.target && !element.style.pointerEvents) {
      element.style.pointerEvents = 'auto';
    }
    /**
     * @protected
     * @type {HTMLElement}
     */


    _this.element = element ? element : null;
    /**
     * @private
     * @type {HTMLElement}
     */

    _this.target_ = null;
    /**
     * @private
     * @type {import("../PluggableMap.js").default|null}
     */

    _this.map_ = null;
    /**
     * @protected
     * @type {!Array<import("../events.js").EventsKey>}
     */

    _this.listenerKeys = [];

    if (options.render) {
      _this.render = options.render;
    }

    if (options.target) {
      _this.setTarget(options.target);
    }

    return _this;
  }
  /**
   * Clean up.
   */


  Control.prototype.disposeInternal = function () {
    (0, _dom.removeNode)(this.element);

    _super.prototype.disposeInternal.call(this);
  };
  /**
   * Get the map associated with this control.
   * @return {import("../PluggableMap.js").default|null} Map.
   * @api
   */


  Control.prototype.getMap = function () {
    return this.map_;
  };
  /**
   * Remove the control from its current map and attach it to the new map.
   * Pass `null` to just remove the control from the current map.
   * Subclasses may set up event handlers to get notified about changes to
   * the map here.
   * @param {import("../PluggableMap.js").default|null} map Map.
   * @api
   */


  Control.prototype.setMap = function (map) {
    if (this.map_) {
      (0, _dom.removeNode)(this.element);
    }

    for (var i = 0, ii = this.listenerKeys.length; i < ii; ++i) {
      (0, _events.unlistenByKey)(this.listenerKeys[i]);
    }

    this.listenerKeys.length = 0;
    this.map_ = map;

    if (map) {
      var target = this.target_ ? this.target_ : map.getOverlayContainerStopEvent();
      target.appendChild(this.element);

      if (this.render !== _functions.VOID) {
        this.listenerKeys.push((0, _events.listen)(map, _MapEventType["default"].POSTRENDER, this.render, this));
      }

      map.render();
    }
  };
  /**
   * Renders the control.
   * @param {import("../MapEvent.js").default} mapEvent Map event.
   * @api
   */


  Control.prototype.render = function (mapEvent) {};
  /**
   * This function is used to set a target element for the control. It has no
   * effect if it is called after the control has been added to the map (i.e.
   * after `setMap` is called on the control). If no `target` is set in the
   * options passed to the control constructor and if `setTarget` is not called
   * then the control is added to the map's overlay container.
   * @param {HTMLElement|string} target Target.
   * @api
   */


  Control.prototype.setTarget = function (target) {
    this.target_ = typeof target === 'string' ? document.getElementById(target) : target;
  };

  return Control;
}(_Object["default"]);

var _default = Control;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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